//@ts-check

//@ts-ignore
const { delay } = require('common-stuffs/utils')(fox);

/**
 * 
 * @param {Fox} fox 
 */
module.exports = (fox, parentPopupName = 'Popup_Common') => {
	return fox.registerWidget('Popup_PromiseCommon', {
		_center(...args) {
			let count = 3;
			let promise = fox.Promise.resolve();

			while(count--) {
				promise = promise
					.then(() => delay(50))
					.then(() => this.callParent('_center', args));
			}
		},

		show(...args) {
			return new fox.Promise((resolver, reject) => {
				this.__resolver = resolver;
				this.__rejecter = reject;
				this.callParent('show', args);
				this._center();
			});
		},

		resolve(params) {
			return this.__resolver(params);
		},

		reject(error) {
			return this.__rejecter(error);
		}
	}, parentPopupName);
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/common-widgets/PromisePopup.es.js